import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3.934 8.002a9 9 0 1 1 -.934 3.998h13","key":"svg-0"}],["path",{"d":"M12 8l4 4l-4 4","key":"svg-1"}]]

const IconCircleOpenArrowRight = createReactComponent('outline', 'circle-open-arrow-right', 'CircleOpenArrowRight', __iconNode);

export default IconCircleOpenArrowRight;